import { writable } from 'svelte/store';
import { login, checkLogin } from "../helpers/db.js";

export const userStore = writable({});


export const customUserStore = {
    set: userStore.set,
    subscribe: userStore.subscribe,
    doLogin: (credentials) => {
        login(credentials).then(user => {
            if (user.id) {
                userStore.set(user);
                customUserStore.set(user);
            }
        });
    },
doLogout: () => {
    login({ username: 'xx' }).then(user => {
        userStore.set(user);
    });
}
}


checkLogin().then(user => {
    if (user.id) {
                        customUserStore.set(user);
                        userStore.set(user);
    }
});


